import React from "react";
import styles from "./LoadingCircle.module.scss";
import cx from "classnames";
const LoadingCircle = ({ loaderStyle }) => {
  return <div className={cx(styles.loader, loaderStyle)}></div>;
};

export default LoadingCircle;
